import { defineComponent as _defineComponent } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import { computed, ref } from 'vue'
import draggable from 'vuedraggable'


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnSelector',
  props: {
    menuHeight: { default: '90vh' }
  },
  setup(__props: any, { expose }) {

const props = __props as { menuHeight: string }


const searchValue = ref<string | null>(null)
const showHiddenColumns = ref(true)
const store = useStore()
const orderedColumns = computed<
  {
    text: string
    value: never
  }[]
>(() => store.getters['jobsList/getOrderedColumns'])
const visibleColumns = computed<string[]>(
  () => store.getters['jobsList/getVisibleColumnIds']
)
const allCoreColumnsSelected = computed<boolean>(
  () => store.getters['jobsList/allCoreColumnsSelected']
)
const allCustomColumnsSelected = computed<boolean>(
  () => store.getters['jobsList/allCustomColumnsSelected']
)
const buildButtonLabel = computed(
  () => `${visibleColumns.value.length} of ${orderedColumns.value.length}`
)
const columnList = computed(() =>
  orderedColumns.value.filter(
    (c) =>
      (showHiddenColumns.value || visibleColumns.value.includes(c.value)) &&
      (!searchValue.value ||
        c.text.toLowerCase().includes(searchValue.value?.toLowerCase()))
  )
)
const orderedColumnIdsModel = computed({
  get() {
    return orderedColumns.value
  },
  set(columnOrder: { text: string; value: never }[]) {
    setColumnOrdering(columnOrder.map((column) => column.value))
  },
})
const setVisibleColumns = (arg: string[]) => {
  store.dispatch('jobsList/updateVisibleColumns', arg)
}
const setColumnOrdering = (arg: string[]) => {
  store.dispatch('jobsList/updateColumnOrder', arg)
}
const toggleCoreColumns = () => {
  store.dispatch('jobsList/toggleCoreColumns')
}
const toggleCustomColumns = () => {
  store.dispatch('jobsList/toggleCustomColumns')
}
const resetColumns = () => {
  store.dispatch('jobsList/resetColumns')
}
const toggleColumnVisibility = (column: { text: string; value: never }) => {
  const index = visibleColumns.value.indexOf(column.value)
  if (index === -1) {
    setVisibleColumns(visibleColumns.value.concat([column.value]))
  } else {
    const columns = [...visibleColumns.value]
    columns.splice(index, 1)
    setVisibleColumns(columns)
  }
}

expose({ buildButtonLabel }) // For unit test

return { __sfc: true,props, searchValue, showHiddenColumns, store, orderedColumns, visibleColumns, allCoreColumnsSelected, allCustomColumnsSelected, buildButtonLabel, columnList, orderedColumnIdsModel, setVisibleColumns, setColumnOrdering, toggleCoreColumns, toggleCustomColumns, resetColumns, toggleColumnVisibility, draggable }
}

})